
import NavigationScrollHandler from '../utils/_navigation-scroll';

/*
 -------------------------------
 Class
 -------------------------------
 */

export default class Navigation {
	ready() {
		const NAVIGATION = document.querySelector('#main_header');
		const NAVIGATION_SCROLLED = 'mtt-navigation--scrolled';

		new NavigationScrollHandler({
			scrollDistance: 80,
			headerElement: NAVIGATION,
			onEnter: addScrollClass,
			onExit: removeScrollClass
		});

		function addScrollClass() {
			if (!NAVIGATION.classList.contains(NAVIGATION_SCROLLED)) {
				NAVIGATION.classList.add(NAVIGATION_SCROLLED);
			}
		}

		function removeScrollClass() {
			if (NAVIGATION.classList.contains(NAVIGATION_SCROLLED)) {
				NAVIGATION.classList.remove(NAVIGATION_SCROLLED);
			}
		}
	}
}